import { Component, Input } from '@angular/core';

@Component({
	selector: 'scrollable-modal',
	templateUrl: 'scrollable-modal.html',
	styleUrls: ['scrollable-modal.css']
})
export class ScrollableModalComponent {
	@Input() id!:string;
	
	constructor() {}
}